import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CashRegister } from '@shared/interfaces/cash-register';
import { IOffice } from '@shared/interfaces/office.interface';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { ProfileService } from '@shared/services/profile.service';
import { TokenService } from '@shared/services/token.service';
import { UtilsService } from '@shared/services/utils.service';
import {
  ConfirmEventType,
  ConfirmationService,
  MessageService,
} from 'primeng/api';
import { environment } from 'src/environments/environment';
import { subMenuItems } from '../submenu';
import { PrinterService } from '@shared/services/printer.service';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';
import { AuthConnectionService } from '@shared/services/auth-connection.service';

@Component({
  selector: 'app-cash-close',
  templateUrl: './cash-close.component.html',
  styleUrls: ['./cash-close.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class CashCloseComponent implements OnInit {
  public employee: any | undefined;
  public office!: IOffice;
  public user!: any;
  public allowOpenCash = false;
  public allowCloseCash = false;
  public months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];
  public today: any;

  public totalSum: number = 0;
  public menuTitle!: string;
  public cashiers: any[] = [];
  public counter: number = 1;
  public cashOutAmount: number = 0;
  public currentCashier: any = null;
  public isCashIn: boolean = false;

  public cashRegister: CashRegister = {
    total: 0,
    totalN: 0,
    totalIncoming: 0,
    totalIncomingN: 0,
    totalOutcoming: 0,
    totalOutcomingN: 0,
    totalInWithoutCashierMoves: 0,
    totalInWithoutCashierMovesN: 0,
    totalOutWithoutCashierMoves: 0,
    totalOutWithoutCashierMovesN: 0,
    cashOutflowTotal: 0,
    cashOutflowN: 0,
    cashOutChangeTotal: 0,
    cashOutChangeN: 0,
    cashInChangeTotal: 0,
    cashInChangeN: 0,
    cashInflowTotal: 0,
    cashInflowN: 0,
    incomingTransfersTotal: 0,
    incomingTransfersN: 0,
    outcomingTransfersTotal: 0,
    outcomingTransfersN: 0,
    cardIncomingTransactionsTotal: 0,
    cardIncomingTransactionsN: 0,
    cardOutcomingTransactionsTotal: 0,
    cardOutcomingTransactionsN: 0,
    bizumIncomingTransactionsTotal: 0,
    bizumIncomingTransactionsN: 0,
    bizumOutcomingTransactionsTotal: 0,
    bizumOutcomingTransactionsN: 0,
    incomingWebTotal: 0,
    incomingWebN: 0,
    outcomingWebTotal: 0,
    outcomingWebN: 0,
  };

  public cashRegisterByTurn: CashRegister = {
    total: 0,
    totalN: 0,
    totalIncoming: 0,
    totalIncomingN: 0,
    totalOutcoming: 0,
    totalOutcomingN: 0,
    totalInWithoutCashierMoves: 0,
    totalInWithoutCashierMovesN: 0,
    totalOutWithoutCashierMoves: 0,
    totalOutWithoutCashierMovesN: 0,
    cashOutflowTotal: 0,
    cashOutflowN: 0,
    cashInflowTotal: 0,
    cashInflowN: 0,
    cashOutChangeTotal: 0,
    cashOutChangeN: 0,
    cashInChangeTotal: 0,
    cashInChangeN: 0,
    incomingTransfersTotal: 0,
    incomingTransfersN: 0,
    outcomingTransfersTotal: 0,
    outcomingTransfersN: 0,
    cardIncomingTransactionsTotal: 0,
    cardIncomingTransactionsN: 0,
    cardOutcomingTransactionsTotal: 0,
    cardOutcomingTransactionsN: 0,
    bizumIncomingTransactionsTotal: 0,
    bizumIncomingTransactionsN: 0,
    bizumOutcomingTransactionsTotal: 0,
    bizumOutcomingTransactionsN: 0,
    incomingWebTotal: 0,
    incomingWebN: 0,
    outcomingWebTotal: 0,
    outcomingWebN: 0,
  };

  public subMenuItems: Array<IToolbarItem> = [];

  public coin_counter: any = {
    '1c': 0,
    '2c': 0,
    '5c': 0,
    '10c': 0,
    '20c': 0,
    '50c': 0,
    '1e': 0,
    '2e': 0,
    '5e': 0,
    '10e': 0,
    '20e': 0,
    '50e': 0,
    '100e': 0,
    '200e': 0,
    '500e': 0,
  };

  constructor(
    public router: Router,
    private apiService: ApiService,
    private http: HttpClient,
    private profileService: ProfileService,
    public utils: UtilsService,
    public tokenService: TokenService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private printerService: PrinterService,
    private subMenuService: PaymentsMenuService,
    private authConnectionService: AuthConnectionService
  ) { }

  async ngOnInit() {
    await this.printerService.connectToStoredDevice();
    this.getAllCashierEntries();
    this.subMenuItems = this.subMenuService.getSubMenuItems();

    this.apiService.getUserAuth().subscribe((response: any) => {
      let office_id = response.office_id;

      this.apiService.getOffice(office_id).subscribe((response: any) => {
        this.office = {
          id: response.id,
          name: response.name,
          code: response.code,
          phone: response.phone,
          email: response.email,
          address: response.address,
          notes: response.notes,
          cashier_status: response.cashier_status ?? 0,
        };
      });
    });

    // this.apiService.get(`/cashier/get/last`).subscribe((response: any) => {
    //   if(!response.datetime_close){
    //     this.currentCashier = response;
    //     let coinCounter = JSON.parse(response.coin_counter);
    //     for(let coin in coinCounter){
    //       this.coin_counter[coin] = coinCounter[coin];
    //     }
    //     this.calculateTotalSum();
    //   }
    // });

    // this.getAllCashiers();

    this.getCurrentUserProps();
  }

  getAllCashierEntries() {

    setTimeout(() => {
      this.apiService
        .get('/cashier-entry/get-all-today')
        .subscribe((response: any) => {
          let totalIncomingN = 0;
          let cashInflowN = 0;

          response.forEach((cashierEntrie: any) => {
            this.cashRegister.total += cashierEntrie.amount;
            this.cashRegister.totalN++;
            if (cashierEntrie.amount > 0) {
              this.cashRegister.totalIncoming += cashierEntrie.amount;
              this.cashRegister.totalIncomingN++;
              if (cashierEntrie.concept != 'Entrada de cambio') {
                this.cashRegister.totalInWithoutCashierMoves += cashierEntrie.amount;
                this.cashRegister.totalInWithoutCashierMovesN++;
              }
              if (cashierEntrie.payment_method == 'EFECTIVO') {
                if (cashierEntrie.concept == 'Entrada de cambio') {
                  this.cashRegister.cashInChangeTotal += cashierEntrie.amount;
                  this.cashRegister.cashInChangeN++;
                } else {
                  this.cashRegister.cashInflowTotal += cashierEntrie.amount;
                  this.cashRegister.cashInflowN++;
                }
              } else if (cashierEntrie.payment_method == 'TRANSFERENCIA') {
                this.cashRegister.incomingTransfersTotal += cashierEntrie.amount;
                this.cashRegister.incomingTransfersN++;
              } else if (cashierEntrie.payment_method == 'TARJETA') {
                this.cashRegister.cardIncomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegister.cardIncomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'BIZUM') {
                this.cashRegister.bizumIncomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegister.bizumIncomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'WEB') {
                this.cashRegister.incomingWebTotal += cashierEntrie.amount;
                this.cashRegister.incomingWebN++;
              }
            }

            if (cashierEntrie.amount < 0) {
              this.cashRegister.totalOutcoming += cashierEntrie.amount;
              this.cashRegister.totalOutcomingN++;
              if (cashierEntrie.concept != 'Pago por caja') {
                this.cashRegister.totalOutWithoutCashierMoves += cashierEntrie.amount;
                this.cashRegister.totalOutWithoutCashierMovesN++;
              }
              if (cashierEntrie.payment_method == 'EFECTIVO') {
                if (cashierEntrie.concept == 'Pago por caja') {
                  this.cashRegister.cashOutChangeTotal += cashierEntrie.amount;
                  this.cashRegister.cashOutChangeN++;
                } else {
                  this.cashRegister.cashOutflowTotal += cashierEntrie.amount;
                  this.cashRegister.cashOutflowN++;
                }
              } else if (cashierEntrie.payment_method == 'TRANSFERENCIA') {
                this.cashRegister.outcomingTransfersTotal += cashierEntrie.amount;
                this.cashRegister.outcomingTransfersN++;
              } else if (cashierEntrie.payment_method == 'TARJETA') {
                this.cashRegister.cardOutcomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegister.cardOutcomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'BIZUM') {
                this.cashRegister.bizumOutcomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegister.bizumOutcomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'WEB') {
                this.cashRegister.outcomingWebTotal += cashierEntrie.amount;
                this.cashRegister.outcomingWebN++;
              }
            }
          });
        });

      this.apiService
        .get('/cashier-entry/get-all-today-by-turn')
        .subscribe((response: any) => {
          let totalIncomingN = 0;
          let cashInflowN = 0;
          response.forEach((cashierEntrie: any) => {
            this.cashRegisterByTurn.total += cashierEntrie.amount;
            this.cashRegisterByTurn.totalN++;
            if (cashierEntrie.amount > 0) {
              this.cashRegisterByTurn.totalIncoming += cashierEntrie.amount;
              this.cashRegisterByTurn.totalIncomingN++;
              if (cashierEntrie.concept != 'Entrada de cambio') {
                this.cashRegisterByTurn.totalInWithoutCashierMoves += cashierEntrie.amount;
                this.cashRegisterByTurn.totalInWithoutCashierMovesN++;
              }
              if (cashierEntrie.payment_method == 'EFECTIVO') {
                if (cashierEntrie.concept == 'Entrada de cambio') {
                  this.cashRegisterByTurn.cashInChangeTotal += cashierEntrie.amount;
                  this.cashRegisterByTurn.cashInChangeN++;
                } else {
                  this.cashRegisterByTurn.cashInflowTotal += cashierEntrie.amount;
                  this.cashRegisterByTurn.cashInflowN++;
                }
              } else if (cashierEntrie.payment_method == 'TRANSFERENCIA') {
                this.cashRegisterByTurn.incomingTransfersTotal +=
                  cashierEntrie.amount;
                this.cashRegisterByTurn.incomingTransfersN++;
              } else if (cashierEntrie.payment_method == 'TARJETA') {
                this.cashRegisterByTurn.cardIncomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegisterByTurn.cardIncomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'BIZUM') {
                this.cashRegisterByTurn.bizumIncomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegisterByTurn.bizumIncomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'WEB') {
                this.cashRegisterByTurn.incomingWebTotal += cashierEntrie.amount;
                this.cashRegisterByTurn.incomingWebN++;
              }
            }

            if (cashierEntrie.amount < 0) {
              this.cashRegisterByTurn.totalOutcoming += cashierEntrie.amount;
              this.cashRegisterByTurn.totalOutcomingN++;
              if (cashierEntrie.concept != 'Pago por caja') {
                this.cashRegisterByTurn.totalOutWithoutCashierMoves += cashierEntrie.amount;
                this.cashRegisterByTurn.totalOutWithoutCashierMovesN++;
              }
              if (cashierEntrie.payment_method == 'EFECTIVO') {
                if (cashierEntrie.concept == 'Pago por caja') {
                  this.cashRegisterByTurn.cashOutChangeTotal += cashierEntrie.amount;
                  this.cashRegisterByTurn.cashOutChangeN++;
                } else {
                  this.cashRegisterByTurn.cashOutflowTotal += cashierEntrie.amount;
                  this.cashRegisterByTurn.cashOutflowN++;
                }
              } else if (cashierEntrie.payment_method == 'TRANSFERENCIA') {
                this.cashRegisterByTurn.outcomingTransfersTotal += cashierEntrie.amount;
                this.cashRegisterByTurn.outcomingTransfersN++;
              } else if (cashierEntrie.payment_method == 'TARJETA') {
                this.cashRegisterByTurn.cardOutcomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegisterByTurn.cardOutcomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'BIZUM') {
                this.cashRegisterByTurn.bizumOutcomingTransactionsTotal +=
                  cashierEntrie.amount;
                this.cashRegisterByTurn.bizumOutcomingTransactionsN++;
              } else if (cashierEntrie.payment_method == 'WEB') {
                this.cashRegisterByTurn.outcomingWebTotal += cashierEntrie.amount;
                this.cashRegisterByTurn.outcomingWebN++;
              }
            }
          });
        });
      this.cdr.detectChanges();
    }, 0);
    this.cdr.detectChanges();

  }

  getAllCashiers() {
    this.apiService.get('/cashier/get').subscribe((response: any) => {
      this.cashiers = response.map((cashier: any) => {
        let coin_counter = JSON.parse(cashier.coin_counter);
        let coin_counter_aux = '';
        for (let key in coin_counter) {
          coin_counter_aux += `<div class="rounded-full bg-green-600 text-white py-1 px-1 inline-block mr-1 mb-1 font-[600]">
            ${key}:${coin_counter[key]}
          </div>`;
        }
        cashier.coin_counter = coin_counter_aux;
        cashier.operation_type =
          cashier.operation_type == 0 ? 'Apertura' : 'Cierre';

        return cashier;
      });
    });
  }

  getCurrentUserProps() {
    this.profileService.getProfile().subscribe((response: any) => {
      this.user = response;

      this.office = this.user.office;
      if (this.office) {
        this.generateTitleSubMenu(this.office.cashier_status);
      }
    });
  }

  generateTitleSubMenu(cashier_status: number) {
    this.menuTitle = cashier_status === 0 ? 'ABRIR CAJA' : 'CERRAR CAJA';
  }

  calculateTotalSum() {
    this.totalSum = Object.keys(this.coin_counter).reduce((sum, key) => {
      return sum + this.coin_counter[key] * this.getCoinValue(key);
    }, 0);


    this.totalSum = parseFloat(this.totalSum.toFixed(2));

  }

  getCoinValue(coin: string): number {
    const coinValues: any = {
      '1c': 0.01,
      '2c': 0.02,
      '5c': 0.05,
      '10c': 0.1,
      '20c': 0.2,
      '50c': 0.5,
      '1e': 1,
      '2e': 2,
      '5e': 5,
      '10e': 10,
      '20e': 20,
      '50e': 50,
      '100e': 100,
      '200e': 200,
      '500e': 500,
    };
    return coinValues[coin] || 0;
  }

  changeResult(value: number) {
    this.calculateTotalSum();
  }

  onAllowConfirmCash() {
    if (this.office && this.office.cashier_status === 0) {
      this.allowOpenCash = true;
    } else if (this.office && this.office.cashier_status === 1) {
      this.allowCloseCash = true;
    }
    this.printerService.openDrawer().catch(err => {
      console.warn('No se pudo abrir el cajón al imprimir ticket:', err);
    });
  }
  onCancelConfirmCash() {
    if (this.office && this.office.cashier_status === 0) {
      this.allowOpenCash = false;

    } else if (this.office && this.office.cashier_status === 1) {
      this.allowCloseCash = false;
    }
  }

  confirmCash() {
    this.allowOpenCash = false;
    this.allowCloseCash = false;
    if (this.office && this.office.cashier_status === 0) {
      if (confirm('¿Estás segura/o de abrir la caja?, recuerda realizar el recuento, por favor.')) {
        this.processOpenCloseCashier(true);
      }
    } else {
      if (confirm('¿Estás segura/o de cerrar la caja?, recuerda realizar el recuento, por favor.')) {
        this.processOpenCloseCashier(false);
      }
    }
  }

  async processOpenCloseCashier($isOpenCashier: boolean) {

    let cashier!: any;
    if ($isOpenCashier) {
      cashier = {
        office_id: this.office.id,
        open_user_id: this.user.id,
        total: this.totalSum,
        coin_counter: JSON.stringify(this.coin_counter),
        operation_type: this.office.cashier_status,
        cash_out_amount: 0
      };
      this.resetAllCoins();

      // Abrir cajón cuando se abre caja
      await this.printerService.openDrawer().catch(err => {
        console.warn('No se pudo abrir el cajón de la impresora:', err);
      });
    } else {
      console.log('hola mundo 2');
      cashier = {
        office_id: this.office.id,
        close_user_id: this.user.id,
        total: this.totalSum,
        coin_counter: JSON.stringify(this.coin_counter),
        operation_type: this.office.cashier_status,
      };

      this.resetAllCoins();

      await this.printerService.openDrawer().catch(err => {
        console.warn('No se pudo abrir el cajón de la impresora:', err);
      });
    }

    this.apiService.post('/cashier/open-close', cashier).subscribe(
      (response: any) => {
        this.getCurrentUserProps();
        this.getAllCashiers();
        const operation_completed: string =
          this.office.cashier_status === 0 ? 'abierto' : 'cerrado';
        let me = JSON.parse(localStorage.getItem('me') || '{}');
        if (me && me.office) {
          me.office.cashier_status = (this.office.cashier_status == 0) ? 1 : 0;
          localStorage.setItem('me', JSON.stringify(me));
        }
        if (!$isOpenCashier) {
          this.printTicketFromCashier(response.id);
        } else {
          (Object.keys(this.cashRegister) as (keyof CashRegister)[]).forEach(key => {
            this.cashRegister[key] = 0;
          });
          (Object.keys(this.cashRegisterByTurn) as (keyof CashRegister)[]).forEach(key => {
            this.cashRegisterByTurn[key] = 0;
          });
          this.getAllCashierEntries();
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Operación completada',
          detail: `Has ${operation_completed} la caja`,
        });
      },
      (error) => {
        if (error.status === 422) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `La operación no se ha podido completar, otro usuario ha abierto caja primero, logueese nuevamente`,
          });

          this.authConnectionService.logout().subscribe({
            next: () => {
              this.router.navigate(['/login']);
            },
            error: () => {
              this.router.navigate(['/login']);
            }
          });
        }else{
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `La operación no se ha podido completar.`,
          });
        }
      }
    );
  }

  resetAllCoins() {
    for (let coin in this.coin_counter) {
      this.coin_counter[coin] = 0;
    }
    this.totalSum = 0;
  }

  printTicketFromCashier(cashierId: number) {
    this.cashOutAmount = 0;
    let printingType = 'pdf';
    this.printerService.printerIsConnected().subscribe((resp: any) => {
      if (resp == true) {
        printingType = 'print';
      }
    });

    if (printingType == 'pdf') {
      this.http
        .get(
          `${environment.baseUrlWeb}/cashier/print-ticket/${cashierId}/${this.cashOutAmount
          }?print_type=${printingType}&token=${this.tokenService.getToken()}`,
          { responseType: 'blob' }
        )
        .subscribe((blob: any) => {
          const blobUrl = URL.createObjectURL(blob);
          let iframe: any = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          iframe.contentWindow?.print();
        });

    } else if (printingType == 'print') {
      this.http
        .get(
          `${environment.baseUrlWeb}/cashier/print-ticket/${cashierId}/${this.cashOutAmount
          }?print_type=${printingType}&token=${this.tokenService.getToken()}`)
        .subscribe((response: any) => {
          const ticket = response as string[];
          this.printerService.printFullTicket(ticket)
            .then(() => {
              // Abrir cajón después de imprimir el ticket
              this.printerService.openDrawer().catch(err => {
                console.warn('No se pudo abrir el cajón al imprimir ticket:', err);
              });
            });
        });
    }

  }

  handleCashCashier(isCashIn: boolean) {
    this.isCashIn = isCashIn;

    this.cashOutAmount = 0;

    this.confirmationService.confirm({
      accept: () => {
        if (Number(this.cashOutAmount) > 0 && !this.isCashIn) {
          this.cashOutAmount *= -1;
        }
        if (Number(this.cashOutAmount) < 0 && this.isCashIn) {
          this.cashOutAmount *= -1;
        }
        this.http
          .post(`${environment.baseUrl}/cashier-entry/save`, {
            concept: (this.isCashIn) ? 'Entrada de cambio' : 'Pago por caja',
            received: this.cashOutAmount,
            amount: this.cashOutAmount,
            payment_method: 'EFECTIVO',
          })
          .subscribe(
            (response: any) => {
              this.cashOutAmount = 0;
              this.messageService.add({
                severity: 'success',
                summary: 'Exito',
                detail: 'Operación procesada, importe procesado',
              });

              this.generateTicketFromCashierEntry(response.id)
            },
            (error: any) => {
              this.cashOutAmount = 0;
              this.messageService.add({
                severity: 'error',
                summary: 'Cancelado',
                detail:
                  'Operación rechazada, hubo un error, comuníquese con el administrador',
              });
            }
          );
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.cashOutAmount = 0;
            this.messageService.add({
              severity: 'error',
              summary: 'Cancelado',
              detail: 'Operación rechazada',
            });
            break;
          case ConfirmEventType.CANCEL:
            this.cashOutAmount = 0;
            this.messageService.add({
              severity: 'error',
              summary: 'Cancelado',
              detail: 'Operación rechazada',
            });
            break;
        }
      },
    });
  }

  generateTicketFromCashierEntry(cashierEntryId: number) {
    this.apiService.post(`/ticket/generate-from-cashier-entry/${cashierEntryId}`, {}).subscribe({
      next: (response: any) => {
        let ticketId = response?.id || null;
        if (ticketId) {
          this.printerService.openDrawer().catch(err => {
            console.warn('No se pudo abrir el cajón de la impresora en operación de caja:', err);
          });
          let printingType = 'pdf';
          this.printerService.printerIsConnected().subscribe((resp: any) => {
            console.log('printerIsConnected', resp);
            if (resp == true) {
              printingType = 'print';
            }
          });
          let ticketData = `${environment.baseUrlWeb}/ticket/imprimir/${ticketId}?print_type=${printingType}&token=${this.tokenService.getToken()}`;
          if (printingType == 'pdf') {
            this.http.get(ticketData, { responseType: 'blob' }).subscribe(
              (blob) => {
                // Crear una URL de objeto para el Blob
                const blobUrl = URL.createObjectURL(blob);

                let iframe: HTMLIFrameElement =
                  document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;
                document.body.appendChild(iframe);
                iframe.onload = () => {
                  iframe.contentWindow?.focus();
                  iframe.contentWindow?.print();
                };
              },
              (error) => {
                console.error('Error al cargar el PDF:', error);
              }
            );
          } else {
            this.http.get(ticketData).subscribe((response) => {
              const ticket = response as string[];
              this.printerService.printFullTicket(ticket);
            });
          }
        }
      }
    }

    );

  }

  exportExcel() {
    window.open(
      `${environment.baseUrlWeb
      }/cashier/export/excel?token=${this.tokenService.getToken()}`
    );
  }
}
